import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import SiteHomepage from './SiteHomepage';
import {fetchDashboardStats} from '../../slices/dashboard.slice';
import ActiveOrdersCard from './Dashboard/ActiveOrdersCard';
import RevenueOverviewCard from './Dashboard/RevenueOverviewCard';
import SystemHealthCard from './Dashboard/SystemHealthCard';
import ContentLibraryCard from './Dashboard/ContentLibraryCard';
import RequestsCard from './Dashboard/RequestsCard';
import OrdersCard from './OrdersCard';
import './Homepage.scss';
import {Col, Container, Row} from 'reactstrap';

const Homepage = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const { stats, status } = useSelector(state => state.dashboard);

    useEffect(() => {
        if (user && ['bac-admin', 'bac-user', 'root' ].includes(user.role)) {
            dispatch(fetchDashboardStats());
        }
    }, [dispatch, user]);

    // Auto-refresh every 30 seconds
    useEffect(() => {
        if (user && ['bac-admin', 'bac-user', 'root' ].includes(user.role)) {
            const interval = setInterval(() => {
                dispatch(fetchDashboardStats());
            }, 30000);

            return () => clearInterval(interval);
        }
    }, [dispatch, user]);

    if (!user) {
        return;
    }

    return (
        <div className="homepage-view min-vh-100 bg-black position-relative">
            { ['bac-admin', 'bac-user', 'root' ].includes(user.role) && (
                <Container fluid className="px-4">
                    {status === 'loading' && !stats && (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {stats && (
                        <>
                            {/* Row 1: Key Metrics Overview */}
                            <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">
                                <Col className="d-flex">
                                    <ActiveOrdersCard data={stats.orders} />
                                </Col>
                                <Col className="d-flex">
                                    <RequestsCard requests={{ count: stats.orders.pending.count }} />
                                </Col>
                                <Col className="d-flex">
                                    <SystemHealthCard data={stats} />
                                </Col>
                            </Row>

                            {/* Row 2: Revenue & Content */}
                            <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">
                                <Col className="d-flex">
                                    <ContentLibraryCard data={stats} />
                                </Col>
                                <Col className="d-flex">
                                    <RevenueOverviewCard data={stats} />
                                </Col>
                                <Col className="d-flex">
                                    <OrdersCard ordersCount={[
                                        { statusWorkflow: 'request-pending', count: stats.orders.pending.count },
                                        { statusWorkflow: 'playing', count: stats.orders.active.playing },
                                        { statusWorkflow: 'ready-to-playback', count: stats.orders.active.readyToPlayback },
                                        { statusWorkflow: 'preparing-playback', count: stats.orders.active.preparingPlayback },
                                        ...Object.entries(stats.orders.active.breakdown)
                                            .filter(([key]) => !['playing', 'ready-to-playback', 'preparing-playback'].includes(key))
                                            .map(([statusWorkflow, count]) => ({ statusWorkflow, count }))
                                    ]} />
                                </Col>
                            </Row>
                        </>
                    )}
                </Container>
            )}

            {['site-admin', 'site-user', 'site-guest'].includes(user.role) && (
                <div className="homepage-view bg-black">
                    <SiteHomepage/>
                </div>
            )}
        </div>
    );
};

export default Homepage;
